import axios from 'axios';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const getSharedFile = ({shumaID, fileID}) => {
  const data = {
    shumaID: parseInt(shumaID, 10),
    fileID: parseInt(fileID, 10),
  };

  return axios.post(api.GET_SHARED_FILE, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return body.file;
    });
};
